module.exports = __webpack_public_path__ + "img/ico-tag.f5e70cc1.svg";